<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000">Watch The Sky</h1>
<p class="calibre3"></p>
<div class="calibre4"><span class="calibre5">It's one thing to try to get away with what you</span></div>
<div class="calibre6">believe to be a lie and be caught at it—</div>
<div class="calibre6">and something different, and far worse</div>
<div class="calibre6">sometimes, to find it isn't a lie ...</div>
<h2 class="sigil_not_in_toc" id="calibre_pb_0"><big class="calibre2">by James H. Schmitz</big></h2>
<p class="calibre7"><span class="small">Illustrated by Hortens</span></p>
<div class="figcenter"><img alt="" class="calibre8" src="Images/Section0003.png" title=""/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?e3ce1d9a